module.exports = __webpack_public_path__ + "static/media/cart.19089ae7.svg";